import { AlertTriangle, Trash2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import type { Collection } from '@/types/collection';

import ModalShell from '@/components/modal-shell';
import { Button } from '@/components/ui/button';

interface DeleteCollectionModalProps {
  collection: Collection;
  onClose: () => void;
  onConfirm: () => void;
}

export default function DeleteCollectionModal({ collection, onClose, onConfirm }: DeleteCollectionModalProps) {
  const { t } = useTranslation();
  const count = collection.experienceCount;
  const nonEmpty = count > 0;

  return (
    <ModalShell title={t('collections.delete.title')} onClose={onClose}
      icon={<Trash2 aria-hidden='true' className='h-5 w-5 shrink-0 text-ws-text' />}>
      <div className='flex flex-col gap-6'>
        <div className='flex flex-col gap-3'>
          <p className='font-medium text-ws-text'>{t('collections.delete.message', { title: collection.title })}</p>
          {nonEmpty && (
            <div className='flex items-start gap-2.5 rounded-lg border border-ws-warning-fg/30 bg-ws-warning-bg px-3 py-2.5'>
              <AlertTriangle aria-hidden='true' className='mt-0.5 h-4 w-4 shrink-0 text-ws-warning-fg' />
              <p className='text-sm text-ws-warning-fg'>{t('collections.delete.cascade', { count })}</p>
            </div>
          )}
          <p className='text-sm text-ws-muted'>{t('collections.delete.irreversible')}</p>
        </div>

        <div className='flex items-center justify-between gap-3'>
          <Button variant='secondary' onClick={onClose}>{t('common.cancel')}</Button>
          <Button variant='primary' onClick={onConfirm}>
            {nonEmpty ? t('collections.delete.confirmCascade', { count }) : t('common.delete')}
          </Button>
        </div>
      </div>
    </ModalShell>
  );
}
